import { rewardsAuthApiClientToken } from "@apps/rewards/tokens";
import { JsonMimeType } from "@lib/ApiClient";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { RewardsReferralContextQueryParams } from "../types";

@singleton()
class RewardsReferralContextApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public setReferralContext(
        params: RewardsReferralContextQueryParams
    ): Observable<unknown> {
        return this.apiClient.post({
            url: "/referral/setReferralContext",
            body: JSON.stringify(params),
            responseType: "text",
            contentType: JsonMimeType,
        });
    }
}

export default RewardsReferralContextApiService;
